import React, { useRef } from "react"
import { Modal, Typography, Space, Button, message } from "@mimber/ui-web"
import { useCancelAnnouncementSchedule } from "@mimber/client/mimber-organization"
import type { CancelAnnouncementScheduleModalProps } from "./CancelAnnouncementScheduleModal.types"

const { Paragraph } = Typography

export const CancelAnnouncementScheduleModal: React.FunctionComponent<
  CancelAnnouncementScheduleModalProps
> = ({ announcement, onSuccess, ...modalProps }) => {
  const closeRef = useRef<(() => void) | null>(null)
  const externalOnCancel = (modalProps as { onCancel?: () => void }).onCancel

  const mutation = useCancelAnnouncementSchedule({
    onSuccess: () => {
      message.success(
        "Announcement schedule cancelled. Announcement moved back to draft."
      )
      closeRef.current?.()
      onSuccess?.()
    },
    onError: (error) => {
      message.error(`Failed to cancel schedule: ${error.message}`)
    },
  })

  return (
    <Modal title="Cancel Scheduled Announcement" footer={null} {...modalProps}>
      {(close) => {
        closeRef.current = close
        return (
          <Space orientation="vertical" size="large" style={{ width: "100%" }}>
            <Paragraph>
              Are you sure you want to cancel the scheduled publish for this
              announcement? It will be moved back to <strong>Draft</strong>{" "}
              status.
            </Paragraph>
            {announcement.scheduledPublishAt && (
              <Paragraph type="secondary">
                Currently scheduled for:{" "}
                {new Date(announcement.scheduledPublishAt).toLocaleString()}
              </Paragraph>
            )}
            <Space style={{ justifyContent: "flex-end", width: "100%" }}>
              <Button
                onClick={() => {
                  close()
                  externalOnCancel?.()
                }}
                disabled={mutation.isPending}
              >
                Keep Schedule
              </Button>
              <Button
                type="primary"
                danger
                loading={mutation.isPending}
                onClick={() => mutation.mutate({ uuid: announcement.uuid })}
              >
                Cancel Schedule
              </Button>
            </Space>
          </Space>
        )
      }}
    </Modal>
  )
}
